export const ANNUAL_BALANCE = "annual_balance";
export const USERS = "users";
export const CONTACT = "contact";
export const PRE_REGISTER = "pre_register";
export const STRATEGIES = "strategies";
export const TRANSACTIONS = "transactions";
export const INVESTMENTS = "investments";
export const PROCESSES = "processes";
export const REFERS = "refers";
